export default "__VITE_ASSET__D60wmWZZ__"